const COUNTRY_PARAM_KEYS = ['buyerCountry', 'buyerCountryAndRegion'];

function hasCountry(params) {
    return COUNTRY_PARAM_KEYS.some((key) => {
        const val = params[key];
        return val != null && String(val).trim() !== '';
    });
}

function getNameFromParams(params) {
    const nameKey = Object.keys(params).find((k) => !COUNTRY_PARAM_KEYS.includes(k));
    return nameKey ? String(params[nameKey] ?? '').trim() : '';
}

/**
 * Sales lead titles use i18n like "{name}（{country}）".
 * When country is missing, return name only (no empty parentheses).
 */
export function formatSalesLeadTitleWithCountry(vm, i18nKey, params) {
    if (!hasCountry(params)) {
        return getNameFromParams(params);
    }
    return vm.$t(i18nKey, params);
}
